import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const assistantFileCreateMutationAtom = createMutationAtomFactory(
  'assistant.fileCreate',
  (params: { fileName: string; fileSize: number; mimeType: string }) => ({
    filesCreateFile: {
      __args: {
        input: {
          fileName: params.fileName,
          fileSize: params.fileSize,
          mimeType: params.mimeType,
          fileType: 'Regular' as const,
          public: false,
        },
      },
      file: {
        id: true,
        fileName: true,
        uploadUrl: true,
      },
      uploadUrl: true,
    },
  }),
);
